import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { Icon } from '../../../components/common/icon/Icon';
import { usePostSignOutMutation } from '../../../hooks/api/auth/mutations/usePostSignOut.mutation';
import { useLayout } from '../../../hooks/screen/useLayout';
import { useGetUserProfile } from '../../../hooks/user/useGetUserProfile';

export const MyInfoDeleteAccountPage = () => {
  const { userProfile } = useGetUserProfile();
  const { mutate: postSignOut } = usePostSignOutMutation();

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} headerTitle={'회원 탈퇴'} />,
    fixedFooter: (
      <ButtonSection>
        <BlurredSection />
        <DeleteAccountButton
          type={'button'}
          onClick={() => {
            postSignOut();
          }}
        >
          <DeleteAccountButtonText>{'탈퇴 하기'}</DeleteAccountButtonText>
        </DeleteAccountButton>
      </ButtonSection>
    ),
    fixedHeaderHeight: 48,
    fixedFooterHeight: 72,
  });

  if (userProfile) {
    return (
      <Container>
        <Title>{'회원 정보 및 개인 서비스 이용기록 삭제'}</Title>
        <DeleteAccountInfoBox>
          <InfoBoxIconWrapper>
            <Icon name={'ExclamationMarkOffblack'} width={14} height={14} />
          </InfoBoxIconWrapper>
          <InfoBoxText>{'회원 탈퇴 하시기 전에 안내사항을 꼭 확인 해주세요!'}</InfoBoxText>
        </DeleteAccountInfoBox>
        <Description>
          <WarningText>{'보유 트랙터, 판매 트랙터, 회원 계정 정보 등'}</WarningText>
          {'은 모두 삭제되며, 삭제된 데이터는 복구가 불가능 합니다.'}
        </Description>
      </Container>
    );
  }

  return <></>;
};

const Container = styled.div`
  display: flex;
  padding: var(--radius-large, 16px) var(--radius-large, 16px) 32px var(--radius-large, 16px);
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
`;

const Title = styled.div`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 15.3px */
`;

const DeleteAccountInfoBox = styled.div`
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const InfoBoxText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const InfoBoxIconWrapper = styled.div`
  display: flex;
  width: 21px;
  height: 21px;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const Description = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Body/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

const WarningText = styled.span`
  color: var(--Light-Scheme-Color-primary-red, #ff3049);
`;

const ButtonSection = styled.div`
  position: relative;
  display: flex;
  width: 100%;

  padding: 0px 16px 32px 16px;
  background-color: white;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const BlurredSection = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-large, 16px);
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 63.96%);

  position: absolute;
  top: -40px;
`;

const Button = styled.button`
  width: 100%;
  height: 40px;
  max-height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  gap: 4px;

  border-radius: var(--radius-medium, 8px);

  &:disabled {
    opacity: 0.3;
  }

  cursor: pointer;
`;

const DeleteAccountButton = styled(Button)`
  background: var(--Light-Scheme-Color-primary-blue, #ff3049);
`;

const DeleteAccountButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
